<template>
  <div>
    <!--loader - message--->
    <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
    <div v-if="parseInt(get_user.verified_status) >= 1">
      <div v-if="congratulation_module && formDisplayVar == ''">
        <div class="middleBox whitebox border radius mb-3">
          <div class="congratulations">
            <div class="logo_congrats">
              <img src="../../../../static/fxView/images/check.svg" alt="Congratulations" />
            </div>
            <div class="subtitle">
              <h3>
                {{ $t("rb_congo") }}
                <span class="green">{{ get_user.profile.firstname }}
                  {{ get_user.profile.lastname }}</span>
              </h3>
              <p class="mb-4 medium">
                {{ $t("createzullu_Your") }}
                <span class="green">{{ platform }}</span>
                {{ $t("liveacc_accounthas") }}
                <span class="green">{{ $t("liveacc_successfully") }}</span>
                {{ $t("liveacc_credentialsare") }}
              </p>
              <ul class="includeWdth">
                <li>
                  <strong> {{ $t("sub_tradingId") }}</strong>
                  {{ account_detail.account_id }}
                </li>
                <li>
                  <strong> {{ $t("lg_password") }}</strong>{{ firstChar(account_detail.password) }}
                </li>
                <li>
                  <strong> {{ $t("dash_Leverage") }}</strong>
                  {{ account_detail.leverage }}
                </li>
                <li>
                  <strong> {{ $t("createzullu_accountBaseCurrency") }}</strong>
                  {{ account_detail.currency }}
                </li>
              </ul>
            </div>
          </div>
          <div
            class="full-width ButtonTrade submitButton align-items-center justify-content-center d-flex mt-4 mb-2 w-100">
            <a class="prism_btn btn_sm darkBG mr-3" href="#" @click.prevent="
              congratulation_module = false;
            reset();
            ">{{ $t("step5_back") }}</a>
            <router-link class="prism_btn btn_sm" to="/account-funding">{{
              $t("fund_now")
            }}</router-link>
            <!-- <a
              class="prism_btn btn_sm"
              href="http://live.actforex.sysfx.com:8100/trade/actlite.jsp?entry=deal.245"
              target="_blank"
              v-if="platform == 'ACT'"
            >
              {{ $t("") }}</a
            >
            <router-link
              class="prism_btn btn_sm"
              :to="{
                path: '/web-trade-link',
                query: {
                  platformVersion: platform.toUpperCase() == 'MT4' ? '4' : '5',
                },
              }"
              target="_blank"
              v-else
              >{{ $t("createzullu_tradenow") }}</router-link
            > -->
          </div>
        </div>
        <div class="middleBox whitebox border radius mb-5">
          <div class="text-center innerTitle pb-3">
            <h2 class="mb-3">{{ $t("dp_download") }} {{ platform }}</h2>
          </div>
          <div class="downloadPlatform d-flex align-items-center">
            <div class="dpBox d-flex align-items-center">
              <a :href="$env_var.downloadPlatformLink[platform.toUpperCase()].window
                " target="_blank">
                <div class="ico">
                  <img src="../../../../static/fxView/images/windows.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("dp_forWindows") }}</p>
                </div>
              </a>
            </div>
            <div class="dpBox d-flex align-items-center">
              <a :href="$env_var.downloadPlatformLink[platform.toUpperCase()].ios
                " target="_blank">
                <div class="ico">
                  <img src="../../../../static/fxView/images/ios.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("dp_forIos") }}</p>
                </div>
              </a>
            </div>
            <div v-if="platform != 'ACT'" class="dpBox d-flex align-items-center">
              <a :href="$env_var.downloadPlatformLink[platform.toUpperCase()].mac
                " target="_blank">
                <div class="ico">
                  <img src="../../../../static/fxView/images/mac_ico.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("dp_forMAC") }}</p>
                </div>
              </a>
            </div>
            <div class="dpBox d-flex align-items-center">
              <a :href="$env_var.downloadPlatformLink[platform.toUpperCase()].actLive
                " target="_blank" v-if="platform == 'ACT'">
                <div class="ico">
                  <img src="../../../../static/fxView/images/android.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("createzullu_forWeb") }}</p>
                </div>
              </a>
              <router-link :to="{path: $env_var.downloadPlatformLink.MT4.webTraderInternalLink, query: { 'platform': 'MT4', 'id': account_detail.account_id }}" target="_blank" v-else-if="platform.toUpperCase() == 'MT4'">
                <div class="ico">
                  <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("createzullu_forWeb") }}</p>
                </div>
              </router-link>
              <a
                title="web_trader"
                :href="`${$env_var.downloadPlatformLink.MT5.webliveAccount}${account_detail.account_id}&server=FXView-Live`"
                target="_blank"
                v-else>
                <div class="ico">
                  <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("createzullu_forWeb") }}</p>
                </div>
              </a>
              <!-- <router-link :to="{
                path: '/web-trade-link',
                query: {
                  platform:
                    platform.toUpperCase(),
                },
              }" target="_blank" v-else>
                <div class="ico">
                  <img src="../../../../static/fxView/images/webtrader.svg" alt="" />
                </div>
                <div class="desc">
                  <p>{{ $t("createzullu_forWeb") }}</p>
                </div>
              </router-link> -->
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!congratulation_module || parseInt(formDisplayVar) == 1">
        {{ chnageAccountTypeFunc }}

        <div id="messageBlock" class="stepForm">
          <div class="mainTitle text-center mt-4 mb-3">
            <h2 class="mb-3">
              {{ $t("createzullu_open") }}
              <span v-html="parseInt(demo_live_select) == 0 ? 'Demo' : 'Live'"></span>
              {{ $t("createzullu_tradingAcc") }}
            </h2>
            <message-component :message="response_msg" :messageType="msg_type"
              v-if="response_msg != ''"></message-component>
          </div>
          <div class="middleBox inMiddle-area radius whitebox p-4 mb-3">
            <div class="row">
              <!-- Platforms -->
              <div class="col-12" v-if="parseInt(get_user.pro_user) == 0">
                <h4 class="mb-3">Platform</h4>
              </div>
              <div class="col-12 col-md-4" v-if="actTraderVar && parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    <p v-html="$t('welcm_actTrader')"></p>
                    <input type="radio" name="platform" value="ACT" v-model="platform" v-validate="'required'"
                      class="float-field form-control" :class="{
                        'is-invalid': submitted && errors.has('platform'),
                      }" ref="platformInput" @focus="platformInput" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-12 col-md-4" v-if="parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    {{ $t("demoacc_MT4") }}
                    <input type="radio" name="platform" value="MT4" v-model="platform" v-validate="'required'"
                      class="float-field form-control" :class="{
                        'is-invalid': submitted && errors.has('platform'),
                      }" ref="platformInput" @focus="platformInput" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-12 col-md-4" v-if="parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">{{ $t("demoacc_MT5") }}
                    <input type="radio" name="platform" value="MT5" v-model="platform" v-validate="'required'"
                      class="float-field form-control" :class="{
                        'is-invalid': submitted && errors.has('platform'),
                      }" ref="platformInput" @focus="platformInput"/>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-12 my-3">
                <ul>
                  <li class="error">{{ errors.first("platform") }}</li>
                </ul>
              </div>
              <!-- Accounts  -->
              <div class="col-12" v-if="parseInt(get_user.pro_user) == 0">
                <h4 class="mb-3">Account</h4>
              </div>
              <div class="col-12 col-md-4 mb-4" v-if="parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    <p>Raw ECN</p>
                    <input type="radio" name="account_type" value="REC" v-model="account_type" v-validate="'required'"
                      class="float-field form-control" :class="{
                        'is-invalid': submitted && errors.has('account_type'),
                      }" ref="account_typeInput" @focus="handleAccountEvent" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-12 col-md-4 mb-4" v-if="parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    <p>Zero Commission</p>
                    <input type="radio" name="account_type" value="STD" v-model="account_type" v-validate="'required'"
                      class="float-field form-control" :class="{
                        'is-invalid': submitted && errors.has('account_type'),
                      }" ref="account_typeInput" @focus="handleAccountEvent"/>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <!-- // :disabled = "!totalDepositAmount >= 5000" -->
              <div class="col-12 col-md-4 mb-4" :class="premiumECN ? 'tooltipcstm' : ''"
                v-if="parseInt(get_user.pro_user) == 0">
                <span class="tooltiptext" v-if="premiumECN">Available for first time deposit of $5000 or equivalent</span>
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    <p>Premium ECN</p>
                    <input type="radio" name="account_type" value="ECN" v-model="account_type"
                      :disabled="premiumECN ? true : false" v-validate="'required'" class="float-field form-control"
                      :class="{
                        'is-invalid': submitted && errors.has('account_type'),
                      }" ref="account_typeInput" @focus="handleAccountEvent" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-12 my-3">
                <ul>
                  <li class="error">{{ errors.first("account_type") }}</li>
                </ul>
              </div>
              <!-- <div class="col-12 col-md-6 mb-4" v-if="parseInt(get_user.pro_user) == 0">
                <div class="customFm border">
                  <label class="customRadio-button m-0">
                    <p>ISLAMIC</p>
                    <input
                      type="radio"
                      name="account_type"
                      value=""
                      v-model="account_type"
                      v-validate="'required'"
                      class="float-field form-control"
                      :class="{
                        'is-invalid': submitted && errors.has('account_type'),
                      }"
                      ref="account_typeInput"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div> -->
              <div class="col-12 mb-3" v-if="parseInt(get_user.pro_user) == 1">
                <div class="slctcurrency">
                  <h4 class="mb-3">{{ $t("dash_currency") }}</h4>
                  <input type="hidden" v-model="select_currency" v-validate="'required'" class="float-field form-control"
                  :class="{ 'is-invalid': submitted && errors.has('select_currency') }" ref="select_currencyInput" name="select_currency" />
                  <ul>
                    <li :class="select_currency == 'USD' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('USD')">
                      <img src="../../../../static/fxView/images/usd.svg" alt="usd" />
                      {{ $t("createzullu_USD") }}
                    </li>
                    <li :class="select_currency == 'EUR' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('EUR')">
                      <img src="../../../../static/fxView/images/eur.svg" alt="eur" />
                      {{ $t("createzullu_EUR") }}
                    </li>
                  </ul>
                </div>
                <p v-if="errors.first('select_currency')">
                  <span class="error">Currency is a required field</span>
                </p>
              </div>
              <div class="col-12 mb-3" v-if="parseInt(get_user.pro_user) == 0">
                <div class="slctcurrency">
                  <h4 class="mb-3">{{ $t("dash_currency") }}</h4>
                  <input type="hidden" v-model="select_currency" v-validate="'required'" class="float-field form-control"
                  :class="{ 'is-invalid': submitted && errors.has('select_currency') }" ref="select_currencyInput" name="select_currency" />
                  <ul>
                    <li :class="select_currency == 'USD' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('USD')">
                      <img src="../../../../static/fxView/images/usd.svg" alt="usd" />
                      {{ $t("createzullu_USD") }}
                    </li>
                    <li :class="select_currency == 'EUR' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('EUR')">
                      <img src="../../../../static/fxView/images/eur.svg" alt="eur" />
                      {{ $t("createzullu_EUR") }}
                    </li>
                    <li :class="select_currency == 'GBP' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('GBP')">
                      <img src="../../../../static/fxView/images/gbp.svg" alt="gbp" />
                      {{ $t("createzullu_GBP") }}
                    </li>
                    <li :class="select_currency == 'AUD' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('AUD')">
                      <img src="../../../../static/fxView/images/aud.svg" alt="aud" />
                      {{ $t("createzullu_AUD") }}
                    </li>
                    <li :class="select_currency == 'ZAR' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('ZAR')">
                      <img src="../../../../static/fxView/images/zar.svg" class="rounded-circle" alt="zar" />
                      {{ $t("createzullu_ZAR") }}
                    </li>
                    <li :class="select_currency == 'CAD' ? 'selected' : ''" @click.prevent="handleCurrencyEvent('CAD')">
                      <img src="../../../../static/fxView/images/cad.svg" alt="aud" />
                      CAD
                      <!-- {{ $t("createzullu_AUD") }} -->
                    </li>
                  </ul>
                </div>
                <p v-if="errors.first('select_currency')">
                  <span class="error">Currency is a required field</span>
                </p>
              </div>
              <div class="col-12 mb-3">
                <input type="hidden" v-model="leverage" v-validate="'required'" class="float-field form-control"
                  :class="{ 'is-invalid': submitted && errors.has('leverage') }" ref="leverageInput" name="leverage" />
                <div class="slctcurrency">
                  <h4 class="mb-3">{{ $t("Dlist_leverage") }}</h4>
                  <ul>
                    <li :class="leverageDisabledFunc(key)" @click.prevent="leverageSelectFuns(key)" v-html="key + 'X'"
                      v-for="(list, key) in $env_var.leverageJson"></li>
                  </ul>
                  <p v-if="errors.first('leverage')">
                    <span class="error">{{ $t("createzullu_leverageField") }}</span>
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-12 border-top pt-3">
                <div class="acPassword">
                  <h3 class="mb-3">{{ $t("lg_password") }}</h3>
                </div>
                <div class="row mt-3">
                  <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                      <div class="mb-3">
                        <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control"
                          v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{8,15}$/, }"
                          name="password" :class="{ 'is-invalid': submitted && errors.has('password'), }"
                          ref="passwordInput" @keyup="testing()" @focus="handlePasswordEvent" v-if="platform == 'MT5'" />
                        <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control"
                          v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*/])\S{6,15}$/, }"
                          name="password" :class="{ 'is-invalid': submitted && errors.has('password'), }"
                          ref="passwordInput" @keyup="testing()"  @focus="handlePasswordEvent" v-else />
                        <label for="password" class="float-label">
                          {{ $t("createzullu_accountPassword") }}</label>
                        <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('1')"></feather>
                      </div>
                      <p class="error" v-for="error in errors.collect('password')" v-if="!submitError">
                        <span v-if="error == 'The password field is required.'">{{ $t("reg_passwordFieldReq") }}</span>
                        <span v-else-if="error == 'The password field format is invalid.'">
                          <span v-if="platform == 'MT5'">{{ $t("cp_passCharval").replace('6', '8') }}</span>
                          <span v-else>{{ $t("cp_passCharval") }}</span>
                        </span>
                      </p>
                      <p class="error" v-if="submitError">
                        <span>{{ $t("demoacc_passwordMust") }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group field-wrapper">
                      <div class="mb-3">
                        <input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control"
                          v-validate="{ required: true, confirmed: password }" name="confirmPassword" :class="{
                            'is-invalid':
                              submitted && errors.has('confirmPassword'),
                          }" ref="confirmPasswordInput" />
                        <label for="password" class="float-label">
                          {{ $t("reg_conPassword") }}</label>
                        <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('2')"></feather>
                      </div>
                      <p class="error" v-for="error in errors.collect('confirmPassword')">
                        <span v-show="error == 'The confirmPassword field is required.'
                          ">{{ $t("reg_passwordFieldReq") }}</span>
                        <span v-show="error ==
                          'The confirmPassword confirmation does not match.'
                          ">{{ $t("reg_newConfFieldSame") }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mt-3">
                <div class="full-width submitButton justify-content-center align-items-center d-flex mt-3 w-100">
                  <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
                    {{ $t("createzullu_createAccount") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- become a pro member -->
          <!-- <div class="alert alert-danger " v-if="get_user.pro_user == 0">
            <router-link :to="'/pro'"><p> {{$t('proMember')}}</p></router-link>
          </div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <no-trading-account :demo_live_both="'w/l'"
        :totalRecords="tradingAccountList.totalLiveAccounts"></no-trading-account>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls';
import * as types from "@/types";
import { mapActions } from "vuex";
export default {
  name: "CREATE-ACCOUNT",
  mixins: [fxViewMixins],
  data() {
    return {
      mszValidation: "",
      pageLoader: false,
      submitError: false,
      response_msg: "",
      msg_type: "",
      select_currency: "EUR",
      account_type: "REC",
      platform: "",
      leverage: "500",
      password: "",
      confirmPassword: "",
      error_msg_password: "",
      submitted: false,

      congratulation_module: false,
      account_detail: {},

      inputtype: "password",
      showpassword: false,
      iconType: "eye-off",
      inputtype1: "password",
      showpassword1: false,
      iconType1: "eye-off",
      demo_live_select: "1",
      numberWithCountry: "",
      numberValid: true,
      actTraderVar: true,
      raw_ecn_account: "",
      zero_commission_account: "",
      totalDepositAmount: '',
      premiumECN: true,
      convertedAmount: null,
      // tooltip: false,
      // title: "Available for first time deposit of $5000 or equivalent"
      //counter: localStorage.getItem("demo_live_form")
    };
  },
  computed: {
    OnlyUsers() {
      // console.log(this.get_user.profile.user_id);
      return [12832, 1173, 59692].includes(this.get_user.profile.user_id);
    },
    chnageAccountTypeFunc() {
      if (
        this.$route.query.pageName &&
        this.$route.query.pageName == "mysql5"
      ) {
        this.actTraderVar = false;
      } else {
        this.actTraderVar = true;
      }
    },
  },
  created() {
    this.$trackEvent('CP+Live+trading+account+Pageview');
    let inputJson = {
      'globalParams': {
        filter: { "deposit.payment_status": 1 },
        sort: { "field": "deposit.created", "type": "ASC" },
        search: ''
      }, 'localParams': { 'parameter': this }
    }
    this._runGetDepositListFTD(inputJson);
    // if(this.$store.getters[Const.GET_DEPOSIT_LIST].records && this.$store.getters[Const.GET_DEPOSIT_LIST].records.length > 0){
    //   let depositAmount = this.$store.getters[Const.GET_DEPOSIT_LIST].records.filter((item) => item.payment_status === "2");
    //   let totalAmount = 0;
    //   for ( let i = 0, length = depositAmount.length; i < length; i++ ) {
    //     totalAmount += parseInt(depositAmount[i].amount);
    //   }
    //   this.totalDepositAmount = totalAmount;
    // }
  },

  methods: {
    errorScroll() {
      console.log(this.formDisplayVar);
      document
        .getElementById("messageBlock")
        .scrollIntoView({ behavior: "smooth" });
    },
    reset() {
      this.password = "";
      this.confirmPassword = "";
      this.leverage = "";
      this.select_currency = "";
      this.account_type = "";
      this.platform = "";
    },
    conversionOfAmount(currency, amount) {
      let conversion_json = {
        globalParams: {
          amount: amount,
          from: currency,
          to: "USD",
        },
        localParams: {
          parameter: this,
          from: 'create-account'
        },
      };
      this._runBitcoinConversion(conversion_json);
    },
    testing() {
      var specialArray = [
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "*",
        "(",
        ")",
        "_",
        "-",
        "+",
        "=",
        "[",
        "]",
        "{",
        "}",
        ";",
        ":",
        '"',
        "/",
        "?",
        ".",
        ">",
        "<",
        "|",
        "/",
        "*",
        ",",
      ];
      var specialArrayAccept = ["!", "@", "#", "$", "%", "^", "*", "/"];
      let truVar = "";

      for (let i = 0; i <= this.password.length - 1; i++) {
        if (specialArray.indexOf(this.password[i]) > 0) {
          if (specialArrayAccept.indexOf(this.password[i]) == -1) {
            truVar = "1";
          }
        }

        if (i == this.password.length - 1) {
          if (truVar == "1") {
            this.submitError = true;
          } else {
            this.submitError = false;
          }
        }
      }
    },
    leverageSelectFuns(getKey) {
      this.$trackEvent('CP+Live+trading+account+Leverage');
      this.leverage = getKey;
    },
    leverageDisabledFunc(getKey) {
      if (parseInt(this.leverage) == parseInt(getKey)) {
        return "selected";
      } else {
        return "";
      }
    },
    updatedText(e) {
      this.numberWithCountry = e.formattedNumber;
      this.numberValid = e.isValid;
    },
    firstChar(getPassword) {
      let first = getPassword.charAt(0);
      let last = getPassword.charAt(getPassword.length - 1);
      return first + "*****" + last;
    },
    switchVisibility(getData) {
      if (getData == "1") {
        this.showpassword = !this.showpassword;
        if (this.showpassword) {
          this.inputtype = "text";
          this.iconType = "eye";
        } else {
          this.inputtype = "password";
          this.iconType = "eye-off";
        }
      } else {
        this.showpassword1 = !this.showpassword1;
        if (this.showpassword1) {
          this.inputtype1 = "text";
          this.iconType1 = "eye";
        } else {
          this.inputtype1 = "password";
          this.iconType1 = "eye-off";
        }
      }
    },

    submit() {
      this.$trackEvent('CP+Live+trading+account+Create+account');
      const _that = this;
      _that.submitted = true;

      if (parseInt(this.get_user.pro_user) == 1) {
        _that.account_type = "ISL";
        _that.platform = "MT4";
        _that.select_currency = _that.select_currency;
      }

      _that.$validator.validate().then((valid) => {
        if (valid && !_that.submitError) {
          let accountJson = {
            globalParams: {
              currency: _that.select_currency,
              account_type: _that.account_type,
              platform: _that.platform,
              leverage: _that.leverage,
              password: _that.password,
              demo_live: _that.demo_live_select.toString(),
            },
            localParams: { parameter: _that },
          };
          _that._runCreateAccount(accountJson);
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
          let list = _that.errors.items.filter(v => v.rule != "required").map(v => v.msg)
          if (list.length) {
            try {
              window.dataLayer.push({
                'event': 'error',
                'errorType': 'create demo tading account error',
                'errorMessage': list.join(',').replace('The password field format is invalid.', this.$t('cp_passCharval'))
              });
            } catch (ex) {
              console.log('ex', ex)
            }
          }
        }
      });
    },
    platformInput(){
      this.$trackEvent('CP+Live+trading+account+Platform');
    },
    handleAccountEvent(){
      this.$trackEvent('CP+Live+trading+account+Account');
    },
    handleCurrencyEvent(currency){
      this.select_currency = currency;
      this.$trackEvent('CP+Live+trading+account+currency');
    },
    handlePasswordEvent(){
      this.$trackEvent('CP+Live+trading+account+Password');
    }
  },
};
</script>
<style>
.tooltipcstm {
  position: relative !important;
  display: inline-block;
  border: none;

}

.tooltipcstm .tooltiptext {
  display: none;
  width: 170px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  position: absolute;
  z-index: 1;
  right: 0;
  left: 0;
  margin: auto;
  top: -85px;
  height: fit-content;
  line-height: 1.4;
}

.tooltipcstm:hover .tooltiptext {
  display: block;
}

.tooltipcstm .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-width: 11px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
  width: fit-content;
  margin: auto;

}</style>



// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/create_account_live.vue